import { matchPath } from 'react-router-dom';
import {
  RoleHelper,
  SCREEN_PRESENTER,
  CAMERA_PRESENTER,
} from '@shoflo/polymer';

import Paths from 'constants/AppPaths';

export function getPathname(getState) {
  const { router } = getState();

  if (!router) return '';

  return router.location.pathname;
}

export function getEventRouteMatch(getState) {
  const pathName = getPathname(getState);

  return matchPath(pathName, {
    path: Paths.EventPage,
  });
}

export function hasEventRouteState(getState) {
  const match = getEventRouteMatch(getState);

  return !!match;
}

export function getCurrentTeamId(getState) {
  const teamRouteMatch = getEventRouteMatch(getState);
  if (!teamRouteMatch) return null;
  return teamRouteMatch.params.teamId;
}

export function getCurrentUserId(getState) {
  const { user } = getState();
  return user._id;
}

export function isAdminForTeam(getState) {
  const { user } = getState();
  const teamId = getCurrentTeamId(getState);
  return RoleHelper.hasTeamAdminRole(user, teamId);
}

export function getBroadcastRouteMatch(getState) {
  const pathName = getPathname(getState);

  return matchPath(pathName, {
    path: Paths.BroadcastPage,
  });
}

/**
 * Helper for executing with current params..
 *
 * @param {*} cb
 */
export function withCurrentParams(cb) {
  return (dispatch, getState, socket) => {
    if (hasEventRouteState(getState)) {
      const match =
        getBroadcastRouteMatch(getState) || getEventRouteMatch(getState);

      cb(dispatch, match.params, getState, socket);
    } else {
      throw new Error(
        'The current route does not have the necessary parameters'
      );
    }
  };
}

/**
 * Checks if meeting attendee response attendeeId is same as the attendeeId
 * parameter passed in.
 *
 * @param {String} attendeeId
 * @param {Object} meeting
 *
 * @return {Boolean} returns true of its meeting attendee is same
 */
export function isSameAttendee(attendeeId, meeting) {
  const AttendeeId =
    meeting &&
    meeting.attendeeResponse &&
    meeting.attendeeResponse.Attendee &&
    meeting.attendeeResponse.Attendee.AttendeeId;
  return AttendeeId === attendeeId;
}

export function isScreenAttendee(attendeeId) {
  return attendeeId.includes('#content');
}

export function isLocalCameraOn(attendeeResponse, attendeeCameraStatus) {
  if (attendeeResponse) {
    const { AttendeeId: attendeeId = '' } = attendeeResponse.Attendee;
    return attendeeCameraStatus[attendeeId];
  }
  return false;
}

export function createSourceFactory({
  broadcastId,
  eventId,
  teamId,
  attendeeId,
  title,
  presenterPhoto,
  userId,
  role,
  ...rest
}) {
  let sourceValue = attendeeId;

  /** Check if the attendee is a screen share*/
  const screenAttendee = isScreenAttendee(attendeeId);

  if (screenAttendee) {
    sourceValue = attendeeId.replace('#content', '');
  }

  return {
    ...rest,
    broadcast: broadcastId,
    event: eventId,
    team: teamId,
    hidden: false,
    title,
    value: attendeeId,
    type: screenAttendee ? SCREEN_PRESENTER : CAMERA_PRESENTER,
    _id: `source_${screenAttendee ? 'screen' : 'cam'}_${sourceValue}`,
    photo: screenAttendee ? null : presenterPhoto,
    userId,
    role,
  };
}

export function readFileAsBinary(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const binaryData = reader.result;
      resolve(binaryData);
    };
    reader.onerror = (error) => {
      reject(error);
    };
    reader.readAsArrayBuffer(file);
  });
}
